// @flow
import React from 'react'
import classnames from 'classnames'

type PropsT = {
  error?: null | string,
  className?: ?string,
  type?: string,
  name: string,
  readOnly?: boolean,
  id?: string,
  placeholder?: string,
  value?: any,
  onChange?: Function,
  returnRef?: Function,
  maxLength?: number
}

const Input = ({
  className,
  type = 'text',
  name,
  id,
  placeholder,
  value,
  readOnly = false,
  onChange = () => {},
  returnRef = () => {},
  maxLength,
  error,
  ...rest
}: PropsT) => {
  const inputProps = {
    className: classnames('Input', className, {
      'Input--error': error,
      'Input--readOnly': readOnly
    }),
    type,
    name,
    id,
    placeholder,
    value,
    onChange,
    readOnly,
    maxLength
  }

  if (!maxLength) delete inputProps.maxLength

  return (
    <input
      {...inputProps}
      {...rest}
    />
  )
}

export default Input
